module.exports = __webpack_public_path__ + "img/home_0.263a0f1f.png";